import { TweenManager } from 'framework/TweenManager/TweenManager';
import { Lerper } from 'framework/utils/Lerper';
import { Range } from 'framework/utils/Range';

export class WarningPillarView extends PIXI.Sprite {
  private readonly alphaLerper: Lerper;

  constructor() {
    super(PIXI.Texture.from("warning_pillar"));
    this.anchor.set(0.5, 1);
    this.alphaLerper = new Lerper({
      initValue: 0,
      lerp: 0.01,
      autoUpdate: true,
      snap: 0.001,
      range: new Range(0, 1),
      destroySignal: this.onDestroyed,
    });
    this.alphaLerper.signals.onValueUpdate.add((value) => this.alpha = value);
  }

  public setWarningLevel(warningLevel: number): void {
    this.alphaLerper.setTarget(warningLevel);
  }
}